module.exports = __webpack_public_path__ + "static/media/Rectangle79.6a11cda6.png";